import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Tailwind sinflarini xavfsiz birlashtirish (keyingisi oldingisini bosadi). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
